module.exports = __webpack_public_path__ + "static/game2-9a0b6cbd432b2bd98a247f2defedc0dd.png";